import React from 'react'
import PropTypes from 'prop-types'
import { Popup } from 'camino-react'

import TimesheetForm from 'Components/Timesheets/TimesheetForm'

const TimesheetModal = ({
  title,
  url,
  method,
  timesheet,
  trigger,
  open,
  onClose,
  modalOpen,
  editableTimesheet,
  viewableTimesheet,
  serviceGroups,
  regionId,
  ticketId,
  newTimesheet,
  defaultServiceGroupId,
  hasManagedServiceGroup,
  ticketStatuses,
  taskId,
  contactName,
  ccOptions,
  statusesRootIds,
  ticketCreatedAt,
  shouldReload,
  ticketTypeId
}) => (
  modalOpen && (
    <Popup
      modal
      trigger={trigger}
      open={open}
      onClose={onClose}
      contentStyle={{
        borderRadius: '10px',
        maxHeight: '95%',
        overflowY: 'auto',
        overflowZ: 'hidden',
        color: '#666'
      }}
      closeOnDocumentClick={false}
    >
      <TimesheetForm
        {...{
          url,
          method,
          title,
          onClose,
          serviceGroups,
          editableTimesheet,
          viewableTimesheet,
          regionId,
          newTimesheet,
          defaultServiceGroupId,
          hasManagedServiceGroup,
          ticketStatuses,
          ticketId,
          taskId,
          contactName,
          ccOptions,
          statusesRootIds,
          ticketCreatedAt,
          shouldReload,
          ticketTypeId
        }}
        {...timesheet}
      />
    </Popup>
  )
)

TimesheetModal.propTypes = {
  showModal: PropTypes.bool,
  newTimesheet: PropTypes.bool,
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
  method: PropTypes.string,
  regionId: PropTypes.oneOf([PropTypes.number, null]),
  timesheet: PropTypes.shape({})
}

TimesheetModal.defaultProps = {
  timesheet: {},
  showModal: false,
  title: 'Timesheet',
  method: 'post',
  editableTimesheet: false,
  viewableTimesheet: false,
  newTimesheet: false,
  regionId: null
}

export default TimesheetModal
